<header class="site-header">
  <div class="site-header__inner">
    <a class="site-header__brand" routerLink="/" aria-label="United Team Building home">
      <img class="site-header__brand-logo" src="assets/UTB-Logo.svg" alt="United Team Building logo" />
      <span class="site-header__brand-text">United Team Building</span>
    </a>

    <button
      #menuToggleButton
      type="button"
      class="site-header__menu-toggle"
      [attr.aria-expanded]="isMenuOpen()"
      [attr.aria-controls]="mobileMenuId"
      aria-label="Toggle navigation menu"
      (click)="toggleMenu()">
      <span class="site-header__menu-toggle-icon" aria-hidden="true">☰</span>
      <span class="site-header__menu-toggle-label">Menu</span>
    </button>

    <nav class="site-header__nav" aria-label="Primary navigation">
      @for (item of navItems; track item.path) {
      <a class="site-header__link"
         [routerLink]="item.path"
         routerLinkActive="is-active"
         [routerLinkActiveOptions]="{ exact: item.path === '/' }"
         (click)="onNavItemSelected()">
        {{ item.label }}
      </a>
      }
    </nav>

    <div class="site-header__actions">
      <a class="site-header__cta" routerLink="/contact-us" (click)="onNavItemSelected()">
        Get Started
      </a>

      <div class="site-header__theme-control">
        <button
          type="button"
          class="site-header__theme-toggle"
          [attr.aria-expanded]="isThemeMenuOpen()"
          aria-haspopup="listbox"
          (click)="toggleThemeMenu()">
          <span class="site-header__theme-gear" aria-hidden="true">⚙</span>
          <span class="site-header__theme-current">{{ getCurrentThemeLabel() }}</span>
        </button>

        @if (isThemeMenuOpen()) {
          <div class="site-header__theme-panel" role="menu" aria-label="Themes">
            <div class="site-header__theme-label">Themes</div>
            @for (option of sortedThemeOptions; track option.value) {
              <button
                type="button"
                class="site-header__theme-option"
                [class.is-active]="currentTheme() === option.value"
                (click)="selectTheme(option.value)">
                {{ option.label }}
              </button>
            }
          </div>
        }
      </div>
    </div>
  </div>

  <button
    type="button"
    class="site-header__backdrop"
    [class.is-open]="isMenuOpen()"
    [attr.aria-hidden]="!isMenuOpen()"
    aria-label="Close navigation menu"
    (click)="closeMenu()"></button>

  <aside
    #mobileDrawer
    [id]="mobileMenuId"
    class="site-header__mobile-drawer"
    [class.is-open]="isMenuOpen()"
    [attr.aria-hidden]="!isMenuOpen()"
    role="dialog"
    aria-modal="true"
    aria-label="Mobile navigation"
    (keydown)="onMenuKeydown($event)">
    <nav class="site-header__mobile-nav" aria-label="Mobile primary navigation">
      @for (item of navItems; track item.path) {
      <a class="site-header__mobile-link"
         [routerLink]="item.path"
         routerLinkActive="is-active"
         [routerLinkActiveOptions]="{ exact: item.path === '/' }"
         (click)="onNavItemSelected()">
        {{ item.label }}
      </a>
      }

      <section
        class="site-header__mobile-theme-section"
        aria-label="Theme selection"
        (mouseenter)="openMobileThemeMenu()"
        (mouseleave)="closeMobileThemeMenu()">
        <button
          type="button"
          class="site-header__mobile-theme-toggle"
          [attr.aria-expanded]="isMobileThemeMenuOpen()"
          [attr.aria-controls]="mobileThemeMenuId"
          (click)="toggleMobileThemeMenu()">
          <span class="site-header__mobile-theme-label">Themes</span>
          <span class="site-header__mobile-theme-current">{{ getCurrentThemeLabel() }}</span>
        </button>

        @if (isMobileThemeMenuOpen()) {
          <div
            [id]="mobileThemeMenuId"
            class="site-header__mobile-theme-options"
            role="listbox"
            aria-label="Choose theme">
            @for (option of sortedThemeOptions; track option.value) {
              <button
                type="button"
                class="site-header__mobile-theme-option"
                [class.is-active]="currentTheme() === option.value"
                [attr.aria-selected]="currentTheme() === option.value"
                (click)="selectThemeFromMobile(option.value)">
                {{ option.label }}
              </button>
            }
          </div>
        }
      </section>

      <a class="site-header__mobile-cta" routerLink="/contact-us" (click)="onNavItemSelected()">
        Get Started
      </a>
    </nav>
  </aside>
</header>
